import { CMS } from "../../components/cms/cms";
import { Show, onMount } from "solid-js";
import { loadAds, loadJurorsCms, setPageTitle, setSubMenu } from "../../app";
import { createStore } from "solid-js/store";
import { ScrollToTarget } from "../../components/scroll-to-target";

type State = {
    isContentReady: boolean;
}

export function JurorsPage() {
    const [state, setState] = createStore<State>({ isContentReady: false } as State);
    onMount(async () => {
        await loadJurorsCms();
        await loadAds("7th-arc-salon/introduction");
        setSubMenu("Jurors");
        setPageTitle({ id: "7th-arc-salon/jurors::page-title", text: "Jurors" });
        setState({ isContentReady: true });
    });
    return (
        <>
            <Show when={state.isContentReady}>
                <ScrollToTarget selector=".juror-link">
                    <div class="text-content">
                        <div class="container" style="padding: 0;">
                            <h4 class="salon-heading-xxl m-t-xxl" style="text-align: center;">
                                <CMS id="label::jurors" text>Jurors</CMS>
                            </h4>
                            <CMS id="jurors::fred-ross"></CMS>
                            <CMS id="jurors::michael-john-angel"></CMS>
                            <CMS id="jurors::vern-swanson"></CMS>
                            <CMS id="jurors::peter-trippi"></CMS>
                        </div>
                    </div>
                </ScrollToTarget>
            </Show>
        </>
    )
}